import React, { useState } from "react"
import { useSwipeable } from 'react-swipeable';
import { useTranslation } from "gatsby-plugin-react-i18next"

import { Text } from "../../Text/Text"
import { ReviewItem } from "./review-item/ReviewItem"

interface OwnProps {
  reviews: {
    review_author: string;
    review_body: string;
  }[];
}

export type ReviewsProps = OwnProps

export const Reviews: React.FC<ReviewsProps> = ({
  reviews
}) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)

  const slideCount = reviews.length

  const onSwipedLeft = (): void => {
    if (slideCount !== currentSlideIndex + 1) {
      setCurrentSlideIndex((prevValue) => prevValue + 1)
    }
  }

  const onSwipedRight = (): void => {
    if (currentSlideIndex > 0) {
      setCurrentSlideIndex((prevValue) => prevValue - 1)
    }
  }

  const handlers = useSwipeable({
    onSwipedLeft,
    onSwipedRight,
    preventScrollOnSwipe: true,
  })

  const slideTranslateValue = `-${(currentSlideIndex / slideCount) * 100}%`;
  
  const { t } = useTranslation("shared", {
    keyPrefix: "location_pages.reviews",
  });

  return (
    <div className="max-w-content-width mx-auto py-8 md:py-16 px-5">
      <Text as="h2" variant="medium-header">{t("title")}</Text>
      <div 
        {...handlers}
        className={`overflow-hidden touch-pan-y`}
      >
        <div 
          className={`flex flex-nowrap overflow-hidden gap-5 mt-12 transition-transform md:grid md:w-auto md:grid-cols-3 md:gap-6 md:max-w-full md:transform-none`}
          data-testid="slide-wrapper"
          style={{
            transform: `translateX(${slideTranslateValue})`,
            width: `${slideCount * 100}%`
          }}
        >
          {reviews?.map((review, index) => {
            return (
              <div className={`w-[100%]`} key={index}>
                <ReviewItem author={review.review_author} body={review.review_body} key={index} />
              </div>
            )
          })}
        </div>
      </div>
      <div className="text-center md:hidden">
        {reviews?.map((review, index) => {
          const indicatorBackground = index === currentSlideIndex ? "bg-turquoise": "bg-cream"
          return (
            <button 
              className={`${indicatorBackground} w-[13px] h-[13px] inline-block mt-7 ml-4 first:ml-0 rounded-xl cursor-pointer`}
              onClick={() => setCurrentSlideIndex(index)}
              key={index}
            >
              <span className="sr-only">{t("slide")} {index + 1}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
